import CreateModule from "@components/modules/expenses/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationExpense } from "@src/components/widgets/AppSubNav/navigation-expense";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Create expense`} navigation={<NavigationExpense />}>
    <CreateModule.Create />
  </MainLayout>
);

export const Route = createFileRoute("/expenses/create")({
  component: Page,
});
